const zh = {
  'app.tagline': '和 AI 一起在白板上想事情',
  'signin.title': '登入 moot',
  'signin.subtitle': '你的白板會保存在帳號裡，任何裝置都能接著用。',
  'signin.google': '使用 Google 繼續',
  'signin.email': 'Email',
  'signin.emailPlaceholder': 'you@example.com',
  'signin.sendLink': '寄送登入連結',
  'signin.dev': '開發環境：以 {email} 登入',
  'signin.none': '目前沒有可用的登入方式。',
  'signin.error': '登入失敗，請再試一次。',
  'signin.checkInbox': '去信箱收信',
  'signin.sentTo': '登入連結已寄到 {email}，10 分鐘內有效。',
  'signin.sentDev': '開發環境：連結印在伺服器的終端機裡。',
  'signin.another': '換一個 email',
  'signin.limited': '登入連結要求得太頻繁了，請過幾分鐘再試。',
  'landing.start': '開始使用',
  'landing.headline': '和 AI 一起，把事情在白板上想清楚',
  'landing.lede':
    '像平常聊天一樣跟 AI 說話。它會把討論整理成白板上的卡片、連線和群組；你隨時可以拖動、改寫，或指著某張卡說話。',
  'landing.p1.title': '聊天就好',
  'landing.p1.body': '一個輸入框、一串對話。需要時，AI 把它看過的東西擺上白板。',
  'landing.p2.title': '白板是你的',
  'landing.p2.body': '你和 AI 改的是同一塊白板。你的每個改動，它下一次都會讀到。',
  'landing.p3.title': '看得到 AI 做了什麼',
  'landing.p3.body': '它讀到了什麼、改了哪裡、為什麼，都攤在你面前，可以追溯。',
  'landing.sketch.card1': '要不要搬到台南',
  'landing.sketch.card2': '生活成本',
  'landing.sketch.group': '考量',
  'landing.sketch.ask': '通勤時間也要算進來',
  'landing.sketch.card3': '通勤',
  'landing.sketch.reply': '加了一張「通勤」卡到「考量」：一個月回台北兩次，影響不大。',
  'boards.title': '我的白板',
  'boards.new': '新白板',
  'boards.empty.title': '還沒有白板',
  'boards.empty.body': '建一塊白板，丟進你正在想的事情，AI 會在旁邊一起整理。',
  'boards.untitled': '未命名白板',
  'boards.rename': '重新命名',
  'boards.delete': '刪除',
  'boards.deleted': '已刪除「{title}」',
  'boards.undo': '復原',
  'boards.updated': '{time}更新',
  'boards.actions': '白板選項',
  'boards.import': '匯入',
  'boards.export': '匯出成檔案',
  'boards.imported': '已匯入「{title}」',
  'boards.open': '打開',
  'boards.importInvalid': '這不是能匯入的白板檔案：{reason}',
  'boards.importTooLarge': '檔案太大，無法匯入（上限 64 MB，單一附件 32 MB）。',
  'boards.cost': '這塊白板上 AI 目前的花費',
  'board.back': '所有白板',
  'board.connecting': '連線中',
  'board.connected': '已連線',
  'board.offline': '離線，正在重新連線',
  'board.notFound': '找不到這塊白板，可能已被刪除。',
  'menu.account': '帳號',
  'menu.theme': '外觀',
  'menu.theme.system': '跟隨系統',
  'menu.theme.light': '淺色',
  'menu.theme.dark': '深色',
  'menu.language': '語言',
  'menu.signOut': '登出',
  'error.tooOld': '這一輪太舊了，它改了什麼已不再保留，無法還原。',
  'error.busy': '這段對話還在進行，結束後才能還原。',
  'error.generic': '發生錯誤，請稍後再試。',
  'author.me': '你',
  'author.someone': '協作者',
  'card.titlePlaceholder': '標題',
  'edge.labelHint': '雙擊加上標籤',
  'card.bodyPlaceholder': '寫點什麼…',
  'mention.label': '指向白板上的東西',
  'mention.empty': '找不到符合的東西',
  'mention.untitled': '未命名',
  'mention.page': '{name} 第 {page} 頁',
  'slash.label': '插入區塊',
  'slash.empty': '沒有這種區塊',
  'slash.text': '文字',
  'slash.h2': '小標題',
  'slash.h3': '小小標題',
  'slash.bullet': '項目清單',
  'slash.ordered': '編號清單',
  'slash.task': '待辦清單',
  'slash.table': '表格',
  'slash.code': '程式碼',
  'slash.quote': '引用',
  'slash.divider': '分隔線',
  'slash.math': '數學公式（獨立一行）',
  'slash.inlineMath': '數學公式（行內）',
  'format.toolbar': '文字格式',
  'format.bold': '粗體',
  'format.italic': '斜體',
  'format.strike': '刪除線',
  'format.code': '程式碼',
  'format.link': '連結',
  'format.heading': '轉成小標題',
  'format.linkPlaceholder': '貼上或輸入網址',
  'format.linkRemove': '移除連結',
  'math.label': 'LaTeX 公式',
  'math.placeholder': '例如 \\frac{a}{b}',
  'math.hint': 'Enter 完成，Esc 取消',
  'math.remove': '刪除公式',
  'block.handle': '拖曳可以移動；拖到白板上會變成新卡片',
  'block.movedOut': '已移到新卡片',
  'block.undoMove': '放回原卡片',
  'file.open': '開啟檔案',
  'group.untitled': '未命名群組',
  'board.conflict': '這個動作和其他人的修改衝突，已略過。',
  'board.emptyHint': '雙擊任何地方寫下一句話，或按 C 新增卡片。也可以直接貼上網址、圖片或檔案。',
  'composer.placeholder': '寫下一句話…',
  'composer.reply': '回覆…',
  'composer.about': '對這個說點什麼…',
  'anchor.untitled': '（無標題）',
  'anchor.capped': '一則訊息最多指向 {n} 個東西，只取了前 {n} 個。',
  'anchor.show': '在白板上顯示它指的東西',
  'anchor.gone': '它指的東西已經不在白板上',
  'anchor.about': '關於 {names}',
  'anchor.sayAboutQuote': '對這段說點什麼',
  'anchor.showComments': '{n} 則關於這張卡的訊息',
  'thread.replies': '{n} 則回覆',
  'thread.fold': '收合 {n} 則回覆',
  'message.actions': '訊息操作',
  'message.reply': '回覆',
  'message.edit': '修改（交給 AI 之前都可以改）',
  'message.toCard': '以這句話開一張新卡',
  'message.inChat': '在對話中查看',
  'sessionNode.gone': '這段對話已不存在',
  'sessionNode.working': '正在處理',
  'sessionNode.updated': '{when}更新',
  'composer.hint': 'Enter 放上白板 · ⌘Enter 放上並交給 AI · Esc 取消',
  'upload.progress': '正在上傳 {name}',
  'upload.failed': '上傳失敗',
  'upload.tooLarge': '檔案超過 32 MB',
  'handoff.title': '把檔案交給 {client}',
  'handoff.titleNoClient': '把檔案交給 AI',
  'handoff.where': '會放到白板「{board}」上。這個連結只能交一個檔案，{minutes} 分鐘內有效。',
  'handoff.drop': '把檔案拖到這裡',
  'handoff.or': '或',
  'handoff.pick': '選擇檔案',
  'handoff.limit': 'PDF、圖片或其他檔案，最大 32 MB。PDF 會加進這塊白板的資料庫。',
  'handoff.sending': '正在傳送 {name}',
  'handoff.done': '已收到 {name}',
  'handoff.doneNext': '回到和 {client} 的對話，跟它說一聲，它就會把檔案放上白板。',
  'handoff.doneNextNoClient': '回到和 AI 的對話，跟它說一聲，它就會把檔案放上白板。',
  'handoff.placed': '{client} 已經把它放上白板「{board}」了。',
  'handoff.placedNoClient': '它已經放上白板「{board}」了。',
  'handoff.gone': '這個連結已經失效',
  'handoff.goneBody': '連結只能用一次，而且 15 分鐘後就會過期。請 AI 再給你一個新的。',
  'handoff.failed': '沒有傳成功，請再試一次。',
  'material.pages': '{n} 頁',
  'material.missing': '找不到這份材料',
  'material.open': '打開閱讀',
  'material.reading': '正在讀取 {name}（{done} / {total} 頁）',
  'material.uploading': '正在上傳 {name}（{done} / {total} 頁）',
  'material.failed': '{name} 無法加入：檔案可能損壞或有密碼',
  'material.tooManyPages': '{name} 超過 2000 頁，目前無法加入',
  'clip.open': '在閱讀器打開這一頁',
  'clip.page': '第 {n} 頁',
  'clip.missing': '原始材料已不在這塊白板上',
  'clip.figure': '從材料剪下的圖',
  'clip.cutAgain': '剪成新的一塊',
  'clip.sayAbout': '對這段說點什麼',
  'reader.close': '關閉閱讀器',
  'reader.pageOf': '{n} / {total}',
  'reader.outline': '目錄',
  'reader.mode': '選取方式',
  'reader.modeText': '選文字',
  'reader.modeRegion': '框選區塊',
  'reader.cut': '剪到白板',
  'reader.ask': '問 AI',
  'reader.cancel': '取消',
  'reader.clipped': '已剪到白板',
  'reader.showClip': '在白板上看',
  'reader.onBoard': '在白板上',
  'reader.regionLabel': '第 {n} 頁的這塊',
  'reader.failed': '這份 PDF 打不開',
  'reader.tabBoard': '白板',
  'search.label': '搜尋白板與材料',
  'search.placeholder': '搜尋卡片、訊息、材料裡的字…',
  'search.results': '搜尋結果',
  'search.none': '找不到',
  'reader.toPage': '到第 {n} 頁',
  'chat.removePointer': '不要指向「{name}」',
  'chat.external':
    '{client} 從外部在這塊白板上工作，它的回覆和改動都在這裡。要跟它說話，請回到 {client}。',
  'toolbar.label': '白板工具',
  'toolbar.card': '新卡片',
  'toolbar.group': '新群組',
  'toolbar.groupSelection': '把選取的東西圍成群組',
  'toolbar.sayAbout': '對選取的東西說點什麼',
  'toolbar.groupDrawHint': '拖出一個範圍來建立群組，Esc 取消',
  'toolbar.upload': '上傳圖片或檔案',
  'toolbar.undo': '復原',
  'toolbar.redo': '重做',
  'zoom.in': '放大',
  'zoom.out': '縮小',
  'zoom.reset': '縮放回 100%',
  'zoom.fit': '顯示全部',
  'sidebar.label': 'AI 對話',
  'sidebar.open': 'AI',
  'sidebar.collapse': '收起側欄',
  'layout.toChat': '以對話為主',
  'layout.toCanvas': '以白板為主',
  'layout.label': '主畫面',
  'layout.chat': '對話',
  'layout.canvas': '白板',
  'canvas.label': '白板',
  'canvas.show': '顯示白板',
  'gallery.title': '從範例開始',
  'gallery.lede': '真實的對話，和它整理出來的白板。',
  'gallery.learning': '學習',
  'gallery.life': '生活',
  'gallery.inZh': '中文',
  'gallery.inEn': '英文',
  'gallery.readOnly': '範例・唯讀',
  'gallery.copy': '複製到我的白板',
  'embed.untitled': '未命名卡片',
  'gallery.copyShort': '複製',
  'gallery.medical': '這是 AI 整理的內容，不構成醫療建議。',
  'canvas.hide': '收起白板',
  'embed.label': '白板內容',
  'embed.region': '白板的一部分',
  'embed.gone': '這個東西已經不在白板上了',
  'embed.empty': '這一區目前沒有東西',
  'embed.changed': '之後有更新',
  'embed.changedHint': '這一輪之後，白板上這部分有改動；這裡顯示的是現在的樣子',
  'embed.peek': '展開',
  'embed.fold': '收合',
  'embed.open': '在白板上打開',
  'session.switch': '切換對話',
  'session.list': '這塊白板的對話',
  'session.untitled': '新對話',
  'session.none': '還沒有對話',
  'session.new': '新對話',
  'session.rename': '重新命名',
  'session.titleLabel': '對話名稱',
  'session.placeOnBoard': '把這段對話放上白板',
  'session.showOnBoard': '在白板上顯示這段對話',
  'session.running': '進行中',
  'session.model': '模型與思考力度',
  'session.effort': '思考力度',
  'session.cost': '這段對話累計 {cost}',
  'effort.low': '低',
  'effort.medium': '中',
  'effort.high': '高',
  'effort.max': '最高',
  'chat.placeholder': '跟 AI 說點什麼…',
  'chat.attach': '附加檔案',
  'chat.send': '送出',
  'chat.removeFile': '移除 {name}',
  'chat.queued': '等待中',
  'chat.handed': '交給 AI {n} 則白板訊息：',
  'chat.failed': '這一輪沒有完成，可以再說一次。原因：',
  'chat.contextFull':
    '這段對話已經超過模型能讀的長度，AI 讀不下了。內容不會被默默截掉；請開一段新對話，它會從目前的白板開始。',
  'chat.stopped': '已停止',
  'chat.silent': '{who} 這一輪沒有回話。',
  'chat.theAi': 'AI',
  'act.toggle': '這一輪做了什麼',
  'board.toggle': 'AI 看到的白板變更',
  'pending.tag': '未送出',
  'pending.saw': '傳送時 AI 會看到：',
  'pending.snapshot': '傳送時 AI 會讀到整塊白板（{n} 項）',
  'board.saw': 'AI 看到：',
  'board.added': '新增了',
  'board.moved': '移動了',
  'board.edited': '編輯了',
  'board.changed': '修改了',
  'board.removed': '刪除了',
  'board.more': '，還有 {n} 處變更',
  'board.raw': '原文',
  'board.someone': '有人',
  'board.ai': 'AI',
  'board.session': '對話「{title}」',
  'board.anItem': '一項',
  'board.anEdge': '一條連線',
  'act.sep': '、',
  'act.created': '建立',
  'act.edited': '修改',
  'act.rewrote': '改寫',
  'act.addedLink': '加入連結',
  'act.moved': '移動',
  'act.deleted': '刪除 {n} 項',
  'act.connected': '連起',
  'act.relabelled': '修改連線',
  'act.unlinked': '移除一條連線',
  'act.grouped': '建立群組',
  'act.regrouped': '調整群組',
  'act.read': '讀了',
  'act.readMaterial': '讀了材料',
  'act.viewedPage': '看了第 {n} 頁',
  'act.searched': '搜尋',
  'act.clipped': '剪下',
  'act.adjustedClip': '調整裁切',
  'act.quoted': '引用',
  'act.addedFile': '放上檔案',
  'act.viewedItem': '看了',
  'act.posted': '在白板上留言',
  'act.other': '執行',
  'act.failed': '沒有成功',
  'act.more': '等 {n} 項',
  'act.moreChanges': '，還有 {n} 項改動',
  'chat.boardSnapshot': '{who} 讀了整塊白板（{n} 項）',
  'chat.boardEmpty': '{who} 讀了白板（空白）',
  'chat.boardChanges': '{who} 讀了上一輪之後的 {n} 處白板變更',
  'chat.stop': '停止',
  'chat.trace': '過程',
  'chat.emptyTitle': '和 AI 一起整理這塊白板',
  'chat.emptyBody': 'AI 看得到整塊白板。在這裡說話，或在白板上寫下一句話後交給它（⌘Enter）。',
  'chat.emptyBodyMain':
    '在這裡說話就好。AI 會把整理出來的東西放在白板上，隨時可以從右上角打開白板來看。',
  'status.thinking': '思考中',
  'status.writing': '正在回覆',
  'status.creatingCard': '正在建立卡片',
  'status.editingCard': '正在修改卡片',
  'status.addingLink': '正在加入連結',
  'status.arranging': '正在調整位置',
  'status.removing': '正在移除',
  'status.connecting': '正在連線',
  'status.grouping': '正在整理群組',
  'status.reading': '正在讀網頁',
  'mention.show': '在白板上顯示',
  'mention.gone': '這個東西已經不在白板上了',
  'hand.to': '交給哪段對話',
  'hand.current': '目前',
  'hand.newSession': '開一段新對話來處理',
  'hand.action': '交給 AI',
  'hand.unfired': '未交出',
  'hand.unfiredHint': '這句話還沒交給 AI',
  'hand.handledBy': '已交給這段對話',
  'pending.title': '待處理',
  'pending.handAll': '全部交給 AI',
  'pending.handPicked': '交出 {n} 則',
  'change.tab': '改動',
  'change.open': '改動',
  'change.summary': '這一輪改了 {n} 項',
  'change.none': '這一輪沒有改動白板。',
  'change.loading': '讀取中…',
  'change.running': '這段對話還在進行，結束後才能還原。',
  'change.added': '新增',
  'change.changed': '修改',
  'change.removed': '移除',
  'change.moved': '移動了位置',
  'change.resized': '改了大小',
  'change.intoGroup': '放進群組「{name}」',
  'change.outOfGroup': '移出群組',
  'change.regrouped': '換了群組',
  'change.renamed': '改名：{from} → {to}',
  'change.relabelled': '標籤：{from} → {to}',
  'change.other': '改了內容',
  'change.text': '改了文字',
  'change.showText': '看文字',
  'change.showDiff': '看文字差異',
  'change.sinceThen': '之後又改成：',
  'change.folded': '⋯ {n} 行沒變',
  'change.intentSep': '；',
  'change.laterBy': '之後被{who}改過：還原時這部分保持現狀',
  'change.show': '在白板上顯示',
  'change.anItem': '一項',
  'change.anEdge': '一條連線',
  'change.removedGhost': '已移除：{label}',
  'change.replay': '重播',
  'change.step': '{i} / {n}',
  'change.prev': '上一步',
  'change.next': '下一步',
  'change.play': '播放',
  'change.pause': '暫停',
  'change.stopReplay': '結束',
  'change.revertTurn': '還原這一輪',
  'change.revertItem': '還原這項',
  'change.revertConfirm': '把 {n} 項放回這一輪之前的樣子？',
  'change.revertConfirmSkip': '其中 {n} 項有部分之後被改過，那些部分會保持現狀。',
  'change.revertDo': '還原',
  'change.revertConfirmKept': 'AI 放上白板的 {n} 則訊息會留著（那是說過的話）。',
  'change.kept': '訊息是說過的話，還原這一輪時會留著。',
  'change.removeMessage': '移除',
  'change.unavailable':
    '這一輪改了白板，但它改了什麼已不再保留在這裡（太舊，或是從別處匯入的對話），所以無法檢視或還原。',
  'change.cancel': '取消',
  'change.reverted': '已還原',
  'change.since': '這則訊息之後的改動',
  'change.sinceBy': '之後被{who}改過',
  'change.sinceNoOld': '這一輪沒有改它們，所以沒有那時的版本可看。',
  'revert.turn': '{who}還原了這一輪，放回 {n} 項',
  'revert.item': '{who}還原了其中一項',
  'revert.skipped': '，略過 {n} 項',
  'revert.undo': '復原',
  'revert.kept': '，留下 {n} 則訊息',
  'revert.reasonUnsupported': '這種改動還不能還原',
  'revert.undone': '已復原',
  'revert.reasonLater': '之後被{who}改過',
  'revert.reasonConflict': '無法放回原狀（例如連線的一端已不在）',
  'trace.tab': '過程',
  'trace.title': '過程',
  'trace.open': '查看過程',
  'trace.close': '關閉',
  'trace.thisTurn': '這一輪',
  'trace.session': '整段對話',
  'trace.empty': '還沒有內容。',
  'trace.input': 'AI 收到的內容',
  'trace.model': '模型輸出',
  'trace.results': '工具結果',
  'trace.notice': '系統通知',
  'trace.end': '結束',
  'trace.notes': '工具外的文字（不會出現在對話裡）',
  'trace.redacted': '（思考內容已隱藏）',
  'error.trialTitle': '試用額度用完了',
  'error.trialBody': '加入你自己的 Anthropic API key 就能繼續使用。訊息會保留在等待中。',
  'error.trialAction': '前往設定',
  'menu.ai': 'AI 與用量',
  'settings.title': 'AI 與用量',
  'settings.back': '回到白板',
  'settings.credit': '試用額度',
  'settings.creditBody': '還剩 {left}（共 {total}）。用完後需要你自己的 API key。',
  'settings.usingKey': '目前使用你自己的 API key，不會扣試用額度。',
  'settings.key': '你的 Anthropic API key',
  'settings.keyBody': 'key 會加密保存，只用來替你呼叫模型。畫面上只顯示最後四碼。',
  'settings.keyPlaceholder': 'sk-ant-…',
  'settings.keySave': '儲存',
  'settings.keyReplace': '更換',
  'settings.keyDelete': '刪除',
  'settings.keyCurrent': '已儲存的 key：…{last4}',
  'settings.keySaved': '已儲存',
  'settings.keyDeleted': '已刪除 key',
  'settings.keyInvalid': '看起來不像 Anthropic API key（應以 sk-ant- 開頭）。',
  'settings.keyRejected': 'Anthropic 不接受這把 key，請確認後再試。',
  'settings.keyUnavailable': '這個環境目前無法保存 API key。',
  'settings.usage': '本月用量',
  'apps.title': '連接其他 AI app',
  'apps.body':
    '讓 Claude Code、Claude 等 AI app 直接讀寫你的白板：讀卡片和材料、新增和修改、在它自己的對話裡回覆。它做的每項改動都會標出來，你可以還原。',
  'apps.url': '連線網址',
  'apps.copy': '複製',
  'apps.copied': '已複製',
  'apps.how': '怎麼連',
  'apps.claude': 'Claude（桌面版與網頁）',
  'apps.other': '其他 app',
  'apps.command': '加入 moot 的指令',
  'apps.claudeCodeStep': '在終端機執行：',
  'apps.claudeStep': '在 Claude 的設定裡打開 Connectors，新增自訂 connector，貼上上面的連線網址。',
  'apps.otherStep': '在 app 的 MCP 設定裡新增一個遠端（HTTP）伺服器，網址填上面的連線網址。',
  'apps.approveOnce': '第一次使用時，瀏覽器會打開 moot，請你登入並允許它。',
  'apps.connected': '已允許的 app',
  'apps.none': '還沒有 app 連進來。',
  'apps.since': '{when}允許',
  'apps.revoke': '撤銷',
  'apps.revokeConfirm': '確定撤銷',
  'apps.keep': '保留',
  'apps.revoked': '已撤銷。它在白板上的對話會留著，但不能再動你的白板。',
  'apps.manage': '管理連線',
  'settings.usageTotal': '本月共 {total}',
  'settings.usageEmpty': '本月還沒有用量。',
  'legal.terms': '服務條款',
  'legal.privacy': '隱私權政策',
} as const

export type MessageKey = keyof typeof zh

const en: Record<MessageKey, string> = {
  'app.tagline': 'Think on a whiteboard, together with AI',
  'signin.title': 'Sign in to moot',
  'signin.subtitle': 'Your boards are saved to your account and follow you across devices.',
  'signin.google': 'Continue with Google',
  'signin.email': 'Email',
  'signin.emailPlaceholder': 'you@example.com',
  'signin.sendLink': 'Email me a sign-in link',
  'signin.dev': 'Dev: sign in as {email}',
  'signin.none': 'No sign-in method is available right now.',
  'signin.error': 'Sign-in failed. Please try again.',
  'signin.checkInbox': 'Check your inbox',
  'signin.sentTo': 'A sign-in link is on its way to {email}. It works for 10 minutes.',
  'signin.sentDev': 'Development: the link is printed in the server terminal.',
  'signin.another': 'Use a different email',
  'signin.limited': 'Too many sign-in links were requested. Please try again in a few minutes.',
  'landing.start': 'Get started',
  'landing.headline': 'Think things through on a whiteboard, with AI beside you',
  'landing.lede':
    'Talk to the AI the way you would in any chat. It lays the discussion out as cards, connections and groups on a board, which you can move, rewrite, or point at.',
  'landing.p1.title': 'Just talk',
  'landing.p1.body':
    'One box, one conversation. When it helps, the AI puts what it found on the board.',
  'landing.p2.title': 'The board is yours',
  'landing.p2.body':
    'You and the AI edit the same board. It reads every change you make, next time it answers.',
  'landing.p3.title': 'See what the AI did',
  'landing.p3.body': 'What it read, what it changed and why are all in the open, step by step.',
  'landing.sketch.card1': 'Move to Tainan?',
  'landing.sketch.card2': 'Cost of living',
  'landing.sketch.group': 'Factors',
  'landing.sketch.ask': 'Count the commute too',
  'landing.sketch.card3': 'Commute',
  'landing.sketch.reply': 'Added Commute to Factors: twice a month is fine.',
  'boards.title': 'Boards',
  'boards.new': 'New board',
  'boards.empty.title': 'No boards yet',
  'boards.empty.body':
    'Create a board, drop in what you are thinking about, and the AI will help you sort it out.',
  'boards.untitled': 'Untitled board',
  'boards.rename': 'Rename',
  'boards.delete': 'Delete',
  'boards.deleted': 'Deleted "{title}"',
  'boards.undo': 'Undo',
  'boards.updated': 'Updated {time}',
  'boards.actions': 'Board options',
  'boards.import': 'Import',
  'boards.export': 'Export to a file',
  'boards.imported': 'Imported "{title}"',
  'boards.open': 'Open',
  'boards.importInvalid': 'This is not a board file that can be imported: {reason}',
  'boards.importTooLarge': 'The file is too large to import (64 MB at most, 32 MB per attachment).',
  'boards.cost': 'What the AI has cost on this board so far',
  'board.back': 'All boards',
  'board.connecting': 'Connecting',
  'board.connected': 'Connected',
  'board.offline': 'Offline, reconnecting',
  'board.notFound': 'This board could not be found. It may have been deleted.',
  'menu.account': 'Account',
  'menu.theme': 'Appearance',
  'menu.theme.system': 'System',
  'menu.theme.light': 'Light',
  'menu.theme.dark': 'Dark',
  'menu.language': 'Language',
  'menu.signOut': 'Sign out',
  'error.tooOld': 'This turn is too old to revert here: what it changed is no longer kept.',
  'error.busy': 'This conversation is still working; revert when it has finished.',
  'error.generic': 'Something went wrong. Please try again later.',
  'author.me': 'You',
  'author.someone': 'Collaborator',
  'card.titlePlaceholder': 'Title',
  'edge.labelHint': 'Double-click to add a label',
  'card.bodyPlaceholder': 'Write something…',
  'mention.label': 'Point at something on the board',
  'mention.empty': 'Nothing matches',
  'mention.untitled': 'Untitled',
  'mention.page': '{name}, page {page}',
  'slash.label': 'Insert a block',
  'slash.empty': 'No such block',
  'slash.text': 'Text',
  'slash.h2': 'Heading',
  'slash.h3': 'Subheading',
  'slash.bullet': 'Bulleted list',
  'slash.ordered': 'Numbered list',
  'slash.task': 'Checklist',
  'slash.table': 'Table',
  'slash.code': 'Code',
  'slash.quote': 'Quote',
  'slash.divider': 'Divider',
  'slash.math': 'Formula (on its own line)',
  'slash.inlineMath': 'Formula (in the line)',
  'format.toolbar': 'Text format',
  'format.bold': 'Bold',
  'format.italic': 'Italic',
  'format.strike': 'Strikethrough',
  'format.code': 'Code',
  'format.link': 'Link',
  'format.heading': 'Turn into a heading',
  'format.linkPlaceholder': 'Paste or type an address',
  'format.linkRemove': 'Remove link',
  'math.label': 'LaTeX formula',
  'math.placeholder': 'e.g. \\frac{a}{b}',
  'math.hint': 'Enter to finish, Esc to cancel',
  'math.remove': 'Delete formula',
  'block.handle': 'Drag to move; drop on the board to make it a new card',
  'block.movedOut': 'Moved to a new card',
  'block.undoMove': 'Put it back',
  'file.open': 'Open file',
  'group.untitled': 'Untitled group',
  'board.conflict': 'That change conflicted with someone else’s and was skipped.',
  'board.emptyHint':
    'Double-click anywhere to write a thought, or press C for a card. You can also paste a link, an image or a file.',
  'composer.placeholder': 'Write a thought…',
  'composer.reply': 'Reply…',
  'composer.about': 'Say something about this…',
  'anchor.untitled': '(untitled)',
  'anchor.capped': 'A message can point at up to {n} things; it points at the first {n}.',
  'anchor.show': 'Show what it is about',
  'anchor.gone': 'What it was about is no longer on the board',
  'anchor.about': 'About {names}',
  'anchor.sayAboutQuote': 'Say something about this',
  'anchor.showComments': 'Messages about this card: {n}',
  'thread.replies': 'Replies ({n})',
  'thread.fold': 'Fold replies ({n})',
  'message.actions': 'Message actions',
  'message.reply': 'Reply',
  'message.edit': 'Edit (until it is handed to the AI)',
  'message.toCard': 'New card from this',
  'message.inChat': 'Show in the conversation',
  'sessionNode.gone': 'This conversation no longer exists',
  'sessionNode.working': 'Working',
  'sessionNode.updated': 'Updated {when}',
  'composer.hint': 'Enter to place · ⌘Enter to place and hand to AI · Esc to cancel',
  'upload.progress': 'Uploading {name}',
  'upload.failed': 'Upload failed',
  'upload.tooLarge': 'Files must be 32 MB or smaller',
  'handoff.title': 'Hand a file to {client}',
  'handoff.titleNoClient': 'Hand a file to the AI',
  'handoff.where':
    'It goes on the board “{board}”. This link takes one file and works for {minutes} minutes.',
  'handoff.drop': 'Drop the file here',
  'handoff.or': 'or',
  'handoff.pick': 'Choose a file',
  'handoff.limit':
    'A PDF, an image or any other file, up to 32 MB. A PDF joins this board’s library.',
  'handoff.sending': 'Sending {name}',
  'handoff.done': '{name} received',
  'handoff.doneNext':
    'Go back to your conversation with {client} and tell it; it will put the file on the board.',
  'handoff.doneNextNoClient':
    'Go back to your conversation with the AI and tell it; it will put the file on the board.',
  'handoff.placed': '{client} has put it on the board “{board}”.',
  'handoff.placedNoClient': 'It is on the board “{board}” now.',
  'handoff.gone': 'This link no longer works',
  'handoff.goneBody':
    'A link takes one file and expires after 15 minutes. Ask the AI for a new one.',
  'handoff.failed': 'That did not go through. Please try again.',
  'material.pages': '{n} pages',
  'material.missing': 'This material is no longer on the board',
  'material.open': 'Open to read',
  'material.reading': 'Reading {name} ({done} / {total} pages)',
  'material.uploading': 'Uploading {name} ({done} / {total} pages)',
  'material.failed': 'Could not add {name}: the file may be damaged or password-protected',
  'material.tooManyPages': '{name} has more than 2000 pages, which is not supported yet',
  'clip.open': 'Open this page in the reader',
  'clip.page': 'p. {n}',
  'clip.missing': 'The material it came from is no longer on this board',
  'clip.figure': 'A figure cut from a material',
  'clip.cutAgain': 'Cut out on its own',
  'clip.sayAbout': 'Say something about this',
  'reader.close': 'Close the reader',
  'reader.pageOf': '{n} / {total}',
  'reader.outline': 'Contents',
  'reader.mode': 'How to select',
  'reader.modeText': 'Select text',
  'reader.modeRegion': 'Draw a box',
  'reader.cut': 'Clip to board',
  'reader.ask': 'Ask AI',
  'reader.cancel': 'Cancel',
  'reader.clipped': 'Clipped to the board',
  'reader.showClip': 'Show on board',
  'reader.onBoard': 'on board',
  'reader.regionLabel': 'this part of p. {n}',
  'reader.failed': 'This PDF cannot be opened',
  'reader.tabBoard': 'Board',
  'search.label': 'Search the board and its materials',
  'search.placeholder': 'Find words in cards, messages and materials…',
  'search.results': 'Results',
  'search.none': 'Nothing found',
  'reader.toPage': 'Go to p. {n}',
  'chat.removePointer': 'Stop pointing at “{name}”',
  'chat.external':
    '{client} works on this board from outside moot; its replies and changes show here. To talk to it, go back to {client}.',
  'toolbar.label': 'Board tools',
  'toolbar.card': 'New card',
  'toolbar.group': 'New group',
  'toolbar.groupSelection': 'Group the selection',
  'toolbar.sayAbout': 'Say something about the selection',
  'toolbar.groupDrawHint': 'Drag out an area to make a group. Esc to cancel.',
  'toolbar.upload': 'Upload an image or file',
  'toolbar.undo': 'Undo',
  'toolbar.redo': 'Redo',
  'zoom.in': 'Zoom in',
  'zoom.out': 'Zoom out',
  'zoom.reset': 'Reset zoom to 100%',
  'zoom.fit': 'Show everything',
  'sidebar.label': 'AI conversation',
  'sidebar.open': 'AI',
  'sidebar.collapse': 'Hide sidebar',
  'layout.toChat': 'Chat as the main view',
  'layout.toCanvas': 'Board as the main view',
  'layout.label': 'Main view',
  'layout.chat': 'Chat',
  'layout.canvas': 'Board',
  'canvas.label': 'Board',
  'canvas.show': 'Show the board',
  'gallery.title': 'Start from an example',
  'gallery.lede': 'Real conversations, and the boards they made.',
  'gallery.learning': 'Learning',
  'gallery.life': 'Life',
  'gallery.inZh': 'Chinese',
  'gallery.inEn': 'English',
  'gallery.readOnly': 'Example · read only',
  'gallery.copy': 'Copy to my boards',
  'embed.untitled': 'Untitled card',
  'gallery.copyShort': 'Copy',
  'gallery.medical': 'Written with AI; not medical advice.',
  'canvas.hide': 'Hide the board',
  'embed.label': 'From the board',
  'embed.region': 'Part of the board',
  'embed.gone': 'This is no longer on the board',
  'embed.empty': 'Nothing in this area now',
  'embed.changed': 'Updated since',
  'embed.changedHint': 'This part of the board changed after this turn; this shows it as it is now',
  'embed.peek': 'Expand',
  'embed.fold': 'Collapse',
  'embed.open': 'Open on the board',
  'session.switch': 'Switch conversation',
  'session.list': 'Conversations on this board',
  'session.untitled': 'New conversation',
  'session.none': 'No conversation yet',
  'session.new': 'New conversation',
  'session.rename': 'Rename',
  'session.titleLabel': 'Conversation title',
  'session.placeOnBoard': 'Place this conversation on the board',
  'session.showOnBoard': 'Show this conversation on the board',
  'session.running': 'Running',
  'session.model': 'Model and effort',
  'session.effort': 'Effort',
  'session.cost': 'This conversation so far: {cost}',
  'effort.low': 'Low',
  'effort.medium': 'Medium',
  'effort.high': 'High',
  'effort.max': 'Max',
  'chat.placeholder': 'Say something to the AI…',
  'chat.attach': 'Attach files',
  'chat.send': 'Send',
  'chat.removeFile': 'Remove {name}',
  'chat.queued': 'Waiting',
  'chat.handed': 'Handed {n} board message(s) to the AI:',
  'chat.failed': 'This turn did not finish; you can say it again. Reason:',
  'chat.contextFull':
    'This conversation is now longer than the model can read. Nothing is cut silently; start a new conversation, which begins from the board as it is now.',
  'chat.stopped': 'Stopped',
  'chat.silent': '{who} did not reply this turn.',
  'chat.theAi': 'The AI',
  'act.toggle': 'What this turn did',
  'board.toggle': 'Board changes the AI saw',
  'pending.tag': 'Not sent',
  'pending.saw': 'When you send, the AI sees: ',
  'pending.snapshot': 'When you send, the AI reads the whole board ({n} items)',
  'board.saw': 'The AI saw: ',
  'board.added': ' added ',
  'board.moved': ' moved ',
  'board.edited': ' edited ',
  'board.changed': ' changed ',
  'board.removed': ' removed ',
  'board.more': ', and {n} more change(s)',
  'board.raw': 'Raw',
  'board.someone': 'Someone',
  'board.ai': 'AI',
  'board.session': 'conversation “{title}”',
  'board.anItem': 'an item',
  'board.anEdge': 'a connection',
  'act.sep': ', ',
  'act.created': 'Created ',
  'act.edited': 'Edited ',
  'act.rewrote': 'Rewrote ',
  'act.addedLink': 'Added link ',
  'act.moved': 'Moved ',
  'act.deleted': 'Removed {n} item(s)',
  'act.connected': 'Connected ',
  'act.relabelled': 'Relabelled ',
  'act.unlinked': 'Removed a connection',
  'act.grouped': 'Grouped as ',
  'act.regrouped': 'Updated group ',
  'act.read': 'Read ',
  'act.readMaterial': 'Read the material ',
  'act.viewedPage': 'Looked at p. {n}',
  'act.searched': 'Searched for ',
  'act.clipped': 'Clipped ',
  'act.adjustedClip': 'Adjusted clip ',
  'act.quoted': 'Quoted ',
  'act.addedFile': 'Added ',
  'act.viewedItem': 'Looked at ',
  'act.posted': 'Posted on the board ',
  'act.other': 'Ran ',
  'act.failed': 'failed',
  'act.more': ' and {n} more',
  'act.moreChanges': ', and {n} more change(s)',
  'chat.boardSnapshot': '{who} read the whole board ({n} items)',
  'chat.boardEmpty': '{who} read the board (empty)',
  'chat.boardChanges': '{who} read {n} board change(s) since its last turn',
  'chat.stop': 'Stop',
  'chat.trace': 'Trace',
  'chat.emptyTitle': 'Work through this board with the AI',
  'chat.emptyBody':
    'The AI sees the whole board. Talk here, or write a thought on the board and hand it over (⌘Enter).',
  'chat.emptyBodyMain':
    'Just talk here. The AI lays things out on the board, which you can open from the top right at any time.',
  'status.thinking': 'Thinking',
  'status.writing': 'Replying',
  'status.creatingCard': 'Creating a card',
  'status.editingCard': 'Editing a card',
  'status.addingLink': 'Adding a link',
  'status.arranging': 'Arranging',
  'status.removing': 'Removing',
  'status.connecting': 'Connecting',
  'status.grouping': 'Grouping',
  'status.reading': 'Reading a web page',
  'mention.show': 'Show on the board',
  'mention.gone': 'This is no longer on the board',
  'hand.to': 'Hand to which conversation',
  'hand.current': 'Current',
  'hand.newSession': 'Start a new conversation for it',
  'hand.action': 'Hand to AI',
  'hand.unfired': 'Not handed',
  'hand.unfiredHint': 'Not handed to the AI yet',
  'hand.handledBy': 'Handed to this conversation',
  'pending.title': 'Waiting for the AI',
  'pending.handAll': 'Hand all to AI',
  'pending.handPicked': 'Hand {n}',
  'change.tab': 'Changes',
  'change.open': 'Changes',
  'change.summary': 'This turn changed {n} thing(s)',
  'change.none': 'This turn did not change the board.',
  'change.loading': 'Loading…',
  'change.running': 'This conversation is still working; you can revert when it has finished.',
  'change.added': 'Added',
  'change.changed': 'Changed',
  'change.removed': 'Removed',
  'change.moved': 'moved',
  'change.resized': 'resized',
  'change.intoGroup': 'put into group “{name}”',
  'change.outOfGroup': 'taken out of its group',
  'change.regrouped': 'moved to another group',
  'change.renamed': 'renamed: {from} → {to}',
  'change.relabelled': 'label: {from} → {to}',
  'change.other': 'content changed',
  'change.text': 'text edited',
  'change.showText': 'Show text',
  'change.showDiff': 'Show text changes',
  'change.sinceThen': 'Changed again since:',
  'change.folded': '⋯ {n} unchanged line(s)',
  'change.intentSep': '; ',
  'change.laterBy': 'Changed afterwards by {who}: a revert leaves that part as it is',
  'change.show': 'Show on the board',
  'change.anItem': 'an item',
  'change.anEdge': 'a connection',
  'change.removedGhost': 'Removed: {label}',
  'change.replay': 'Replay',
  'change.step': '{i} / {n}',
  'change.prev': 'Previous step',
  'change.next': 'Next step',
  'change.play': 'Play',
  'change.pause': 'Pause',
  'change.stopReplay': 'Done',
  'change.revertTurn': 'Revert this turn',
  'change.revertItem': 'Revert this',
  'change.revertConfirm': 'Put {n} thing(s) back as they were before this turn?',
  'change.revertConfirmSkip':
    ' {n} of them were partly changed afterwards; those parts stay as they are.',
  'change.revertDo': 'Revert',
  'change.revertConfirmKept':
    ' {n} message(s) the AI put on the board stay (they are what was said).',
  'change.kept': 'A message is what was said: reverting the turn keeps it.',
  'change.removeMessage': 'Remove',
  'change.unavailable':
    'This turn changed the board, but what it changed is no longer kept here (too old, or a conversation imported from elsewhere), so it cannot be shown or reverted.',
  'change.cancel': 'Cancel',
  'change.reverted': 'Reverted',
  'change.since': 'Changes since this message',
  'change.sinceBy': ' changed afterwards by {who}',
  'change.sinceNoOld': 'This turn did not change them, so there is no version from then to show.',
  'revert.turn': '{who} reverted this turn: {n} thing(s) put back',
  'revert.item': '{who} reverted one of its changes',
  'revert.skipped': ', {n} skipped',
  'revert.undo': 'Undo',
  'revert.kept': ', {n} message(s) kept',
  'revert.reasonUnsupported': ' is a kind of change that cannot be reverted yet',
  'revert.undone': 'Undone',
  'revert.reasonLater': ' changed afterwards by {who}',
  'revert.reasonConflict': ' could not be put back (e.g. one end of a connection is gone)',
  'trace.tab': 'Trace',
  'trace.title': 'Trace',
  'trace.open': 'Show trace',
  'trace.close': 'Close',
  'trace.thisTurn': 'This turn',
  'trace.session': 'Whole conversation',
  'trace.empty': 'Nothing yet.',
  'trace.input': 'What the AI received',
  'trace.model': 'Model output',
  'trace.results': 'Tool results',
  'trace.notice': 'System notice',
  'trace.end': 'End',
  'trace.notes': 'Text outside tools (never shown in the chat)',
  'trace.redacted': '(thinking hidden)',
  'error.trialTitle': 'Trial credit is used up',
  'error.trialBody': 'Add your own Anthropic API key to keep going. Your messages stay queued.',
  'error.trialAction': 'Open settings',
  'menu.ai': 'AI and usage',
  'settings.title': 'AI and usage',
  'settings.back': 'Back to boards',
  'settings.credit': 'Trial credit',
  'settings.creditBody': '{left} left of {total}. After that you need your own API key.',
  'settings.usingKey': 'Using your own API key; trial credit is not spent.',
  'settings.key': 'Your Anthropic API key',
  'settings.keyBody':
    'Stored encrypted and only used to call the model for you. Only the last four characters are shown.',
  'settings.keyPlaceholder': 'sk-ant-…',
  'settings.keySave': 'Save',
  'settings.keyReplace': 'Replace',
  'settings.keyDelete': 'Delete',
  'settings.keyCurrent': 'Saved key: …{last4}',
  'settings.keySaved': 'Saved',
  'settings.keyDeleted': 'Key deleted',
  'settings.keyInvalid':
    'That does not look like an Anthropic API key (it should start with sk-ant-).',
  'settings.keyRejected': 'Anthropic did not accept this key. Check it and try again.',
  'settings.keyUnavailable': 'This deployment cannot store API keys right now.',
  'settings.usage': 'This month',
  'apps.title': 'Connect other AI apps',
  'apps.body':
    'Let AI apps such as Claude Code and Claude work on your boards directly: read cards and materials, add and change things, and reply in their own conversation. Everything they change is marked, and you can revert it.',
  'apps.url': 'Connection address',
  'apps.copy': 'Copy',
  'apps.copied': 'Copied',
  'apps.how': 'How to connect',
  'apps.claude': 'Claude (desktop and web)',
  'apps.other': 'Other apps',
  'apps.command': 'The command that adds moot',
  'apps.claudeCodeStep': 'Run this in a terminal:',
  'apps.claudeStep':
    "In Claude's settings, open Connectors, add a custom connector and paste the address above.",
  'apps.otherStep': "In the app's MCP settings, add a remote (HTTP) server with the address above.",
  'apps.approveOnce':
    'The first time it is used, your browser opens moot so you can sign in and allow it.',
  'apps.connected': 'Allowed apps',
  'apps.none': 'No app has connected yet.',
  'apps.since': 'Allowed {when}',
  'apps.revoke': 'Revoke',
  'apps.revokeConfirm': 'Revoke now',
  'apps.keep': 'Keep',
  'apps.revoked':
    'Revoked. Its conversations on your boards stay, but it can no longer change them.',
  'apps.manage': 'Manage connections',
  'settings.usageTotal': '{total} this month',
  'settings.usageEmpty': 'No usage this month yet.',
  'legal.terms': 'Terms',
  'legal.privacy': 'Privacy',
}

export const messages = { 'zh-Hant': zh as Record<MessageKey, string>, en }
export type Locale = keyof typeof messages

/** The page title outside a board: the name and what it is for, in `l`. */
export const appTitle = (l: Locale) => `moot — ${messages[l]['app.tagline']}`
export const LOCALES: { id: Locale; label: string }[] = [
  { id: 'zh-Hant', label: '繁體中文' },
  { id: 'en', label: 'English' },
]
